import axios from "axios";
import { API_BASE } from "../config";

/**
 * 📨 Récupérer les messages
 * - par affaire
 * - optionnellement par paire (me <-> notaire)
 */
export const fetchMessages = async ({
  affaireId,
  me,
  notaireEmail,
} = {}) => {
  try {
    const response = await axios.get(`${API_BASE}/api/messages`, {
      params: {
        affaireId,
        me,
        notaireEmail,
      },
    });

    return response.data?.messages || [];
  } catch (error) {
    console.error("Erreur fetchMessages:", error);
    return [];
  }
};

/**
 * 📥 Inbox notaire
 * Tous les messages où me est sender OU receiver
 */
export const fetchInbox = async ({ me }) => {
  try {
    const response = await axios.get(`${API_BASE}/api/messages/inbox`, {
      params: { me },
    });

    return response.data?.messages || [];
  } catch (error) {
    console.error("Erreur fetchInbox:", error);
    return [];
  }
};

/**
 * ✉️ Envoyer un message
 * (Zapier est déclenché côté BACK)
 */
export const sendMessage = async (
  sender,
  receiver,
  content,
  affaire
) => {
  try {
    await axios.post(`${API_BASE}/api/messages`, {
      sender,
      receiver,
      content,
      id_affaire: affaire.id,
    });

    return true;
  } catch (error) {
    console.error("Erreur sendMessage:", error);
    return false;
  }
};

/**
 * 👀 Marquer une conversation comme lue
 * Tous les messages envoyés par contactEmail vers me
 */
export const markThreadRead = async ({ me, contactEmail }) => {
  try {
    await axios.post(`${API_BASE}/api/messages/mark-read`, {
      me,
      contactEmail,
    });
    return true;
  } catch (error) {
    console.error("Erreur markThreadRead:", error);
    return false;
  }
};